export class ContaPagar {
    id: number;
    valor: any;
    juros: any;
    multa: any;
    desconto: any;
    total: any;
    fornecedorId: number | null;
    dtVencimento: any;
    dtPagamento: any;
    parcela: String;	
    pagamento: any;
    situacao: any;
    observacao:String;
    favorecido: string;
    clienteId: number | null;
    colaboradorId?: number | null;
    descricao:String;
    nrDocumento:String;
    codigoBarras:String;
    favorecidoId: number | null;
    favorecidoDescricao: string | null;
    segmentoId?: number | null;
    situacaoDescricao?: string;
    possuiAnexoFatura?: boolean;
    nomeArquivoFatura?: string;
    possuiAnexoBaixa?: boolean;
    nomeArquivoBaixa?: string;
    valorBaixa?: number;


    constructor(id: number, valor: any,juros: any, multa: any,desconto: any, total: any,fornecedorId: number | null,
        dtVencimento: any,dtPagamento: any,parcela: String,pagamento: any, situacao: any, observacao:String,
        favorecido: string, clienteId: number | null, descricao: string, nrDocumento: string, codigoBarras: string, favorecidoId: number | null, favorecidoDescricao: string | null) {
        this.id = id;
        this.valor = valor;
        this.juros = juros;
        this.multa = multa;
        this.desconto = desconto;
        this.total = total;
        this.fornecedorId = fornecedorId;
        this.dtVencimento = dtVencimento;
        this.dtPagamento = dtPagamento;
        this.parcela = parcela;
        this.pagamento = pagamento;
        this.situacao = situacao;
        this.observacao = observacao;
        this.favorecido = favorecido;
        this.clienteId = clienteId;
        this.descricao = descricao;
        this.nrDocumento = nrDocumento;
        this.codigoBarras = codigoBarras;
        this.favorecidoId = favorecidoId;
        this.favorecidoDescricao = favorecidoDescricao;
    }
}